const initialState = {
  ptoData: { attachments: [] },
  currentPTOViewTab: "New",
  refreshPTOComments: true,
};

export const PTOReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_PTO":
      return {
        ...state,
        ptoData: action.payload
      };

    case "SET_PTO_VIEW_TAB":
      return {
        ...state,
        currentPTOViewTab: action.payload
      };

    case "SET_REFRESH_PTO_COMMENTS":
      return {
        ...state,
        refreshPTOComments: action.payload
      };

    case "RESET_PTO_STATE":
      return initialState;

    default:
      return state;
  }
};

/* ---------- Action Creators ---------- */

export const setpto = (ptoData) => ({
  type: "SET_PTO",
  payload: ptoData,
});

export const setPTOViewTab = (currentTab) => ({
  type: "SET_PTO_VIEW_TAB",
  payload: currentTab,
});

export const setRefreshPTOComments = (value) => ({
  type: "SET_REFRESH_PTO_COMMENTS",
  payload: value,
});

export const resetPTOState = () => ({
  type: "RESET_PTO_STATE",
});
